import { render } from "./OfferTabs.vue?vue&type=template&id=64c106ae"
import script from "./OfferTabs.vue?vue&type=script&lang=js"
export * from "./OfferTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__